import React, { useCallback, useEffect, useState } from 'react'
import { LinkButton } from '@zera-admin/button'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Page, { PageHeader } from '@zera-admin/page'
import Table from '@zera-admin/table'

import { usePopupContext } from 'app/contexts/popup'
import MainLayout from 'layouts/main'
import appService, {
  AppListRequest,
  AppListResponse,
} from 'services/http/identity-server/app'
import Pager from 'components/pager'

import { AppListProps } from './types'

const AppList: React.FunctionComponent<AppListProps> = ({ location }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [values, setValues] = useState<AppListResponse>()
  const [popup] = usePopupContext()

  const getValues = useCallback(
    async (request: AppListRequest) => {
      try {
        const response = await appService.get(request)

        setValues(response.data)
      } catch {
        popup.add({
          title: 'Uygulamalar getirilemedi',
          children:
            'Uygulama listesi getirilirken bir sorun oluştu, lütfen sayfayı yenileyip tekrar deneyin.',
        })
      }

      setIsLoading(false)
    },
    [popup]
  )

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)

    getValues({
      pageSize: 15,
      pageIndex: parseInt(searchParams.get('pageIndex') || '1') - 1,
    })
  }, [getValues, location.search])

  const breadcrumbs = (
    <Breadcrumb>
      <BreadcrumbItem text="Anasayfa" href="/" />
      <BreadcrumbItem text="Uygulamalar" />
    </Breadcrumb>
  )

  return (
    <MainLayout>
      <Page>
        <PageHeader
          actions={
            <LinkButton appearance="primary" href="/app/create">
              Uygulama oluştur
            </LinkButton>
          }
          bottomBar={
            <p>
              Kullanıcı yönetimi üzerinde kayıtlı tüm uygulamaları
              görüntüleyebilir, yeni uygulama oluşturabilir veya
              düzenleyebilirsiniz.
            </p>
          }
          breadcrumbs={breadcrumbs}
        >
          Uygulamalar
        </PageHeader>
        <Table
          columns={
            [
              {
                name: 'name',
                text: 'Uygulama adı',
              },
              {
                name: 'operation',
                text: 'İşlem',
                width: '100px',
                render: (row: any) => (
                  <LinkButton
                    appearance="subtle-link"
                    href={`/app/update/${row.id}`}
                    size="none"
                    style={{ padding: '5px 0px' }}
                  >
                    Görüntüle
                  </LinkButton>
                ),
              },
            ] as any
          }
          rows={values ? values.data : []}
          helperMessage="Aradığınız kriterlere ait sonuç bulunamadı, lütfen tekrar deneyin."
          isLoading={isLoading}
        />
        <Pager pages={values?.meta.totalPage || 1} />
      </Page>
    </MainLayout>
  )
}

export default AppList
